import React from 'react';
import PropTypes from 'prop-types';
import i18n from '~shared/utils/i18n';
import './styles.scss';

const EventIcons = ({
    showBoostedIcons = false,
    showEachWayPlus = false,
    showStreaming = false,
    extraClassname = '',
    isOddsBoost = false,
    oddsBoostCount = 0,
}) => {

    const showOddsBoostCounter = isOddsBoost && oddsBoostCount > 1;

    return (
        <div className={`event-icons ${extraClassname}`}>
            {Boolean(showBoostedIcons) && (
                <span className="event-icons-boosted-odds" />
            )}
            {Boolean(showEachWayPlus) && (
                <span className="event-icons-ew-plus">
                    {i18n.t('racing.ew_plus')}
                </span>
            )}
            {Boolean(showStreaming) && (
                <span className="event-icons-streaming" />
            )}
            {isOddsBoost && (
                <div className="event-icons-odds-boost">
                    {showOddsBoostCounter &&
                        <div className="event-icons-odds-boost-counter">
                            {oddsBoostCount}
                        </div>
                    }
                    <div className="event-icons-odds-boost-icon" />
                </div>
            )}
        </div>
    );
};

EventIcons.propTypes = {
    showBoostedIcons: PropTypes.bool,
    showEachWayPlus: PropTypes.bool,
    showStreaming: PropTypes.bool,
    isOddsBoost: PropTypes.bool,
    oddsBoostCount: PropTypes.number,
    extraClassname: PropTypes.string,
};

export default EventIcons;
